import { render, staticRenderFns } from "./EditarEmpleado.vue?vue&type=template&id=3eb5a186"
import script from "./EditarEmpleado.vue?vue&type=script&lang=js"
export * from "./EditarEmpleado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports